// extracted by mini-css-extract-plugin
module.exports = {"btn":"BtnMenu_btn__WzjrQ","bonjour":"BtnMenu_bonjour__3fC86","initial":"BtnMenu_initial__2Eks4","isMenuCompteOpen":"BtnMenu_isMenuCompteOpen__2zQDJ"};